export default function removePunctuation(word){
  let newWord = '';
  let punctuation = [".", '"', "'", ",", "!", "?", ":", ";", "(", ")", "¿", "”", "“"];
  newWord = word.split("");
  newWord = newWord.map((item, index) => {
    if (punctuation.indexOf(item) < 0) return item;
  });
  newWord = newWord.join("");
  return newWord;
}